import { render, staticRenderFns } from "./DeviceGroupList.vue?vue&type=template&id=2abb141d&scoped=true&"
import script from "./DeviceGroupList.vue?vue&type=script&lang=js&"
export * from "./DeviceGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb141d",
  null
  
)

export default component.exports